import { delay } from "../../../utils"
import { rest } from "msw"

export const shippings = [
  rest.get("*/v1/stores/:storeID/shippings/", function (_req, res, ctx) {
    return res(delay(ctx), ctx.json(require("./get.fixture.json")))
  }),
]
